import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const DraftsIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="M16.28 6.43 8.29 14.4a1 1 0 0 0-.26.47l-1 4a1 1 0 0 0 1.21 1.21l4-1a1 1 0 0 0 .47-.26l9.5-9.5a3.12 3.12 0 1 0-4.42-4.42l-1.48 1.5h-.02v.02Zm2.93-.1a1.12 1.12 0 0 1 1.58 1.58l-.79.8-1.59-1.59.8-.8ZM17 8.53l1.59 1.6-7.1 7.09-.7.17a1.01 1.01 0 0 0-.08-.1l-.98-.97.17-.69 7.1-7.1Z"
      clipRule="evenodd"
    />
    <path d="M1 6.12a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1Zm1 3a1 1 0 0 0 0 2h7a1 1 0 1 0 0-2H2Zm-1 5a1 1 0 0 1 1-1h3a1 1 0 1 1 0 2H2a1 1 0 0 1-1-1Z" />
  </Icon>
));
export default DraftsIcon;
